import { Outlet } from '@tanstack/react-router';

import { FeatureNotEnabledView } from 'common/components/cookbook/FeatureNotEnabledView/FeatureNotEnabledView';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

import { useInventoryServiceFeatureEnabled } from '../common/hooks/useWarehouseFeatureEnabled';

const StockCountEnabledRoute = () => {
  const f = useFormatMessage();
  const enabled = useInventoryServiceFeatureEnabled();
  const viewTitle = f('stock_count.stock_count');

  if (enabled) {
    return <Outlet />;
  }

  return (
    <FeatureNotEnabledView
      viewTitle={viewTitle}
      description={f('warehouse.common.feature_not_enabled')}
    />
  );
};

export default StockCountEnabledRoute;
